import axios from 'axios'

//WARNING: right now we need this import BUT, this MUST be deleted as long the backend is ready with the call
import { API_TO_QFIELD } from '@/qunit/fields_mapping';

export default {
  delete: async (centro, id) => {
    const url = `${centro}/businessprocess/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (centro, id) => {
    const url =
      id === undefined
        ? `${centro}/businessprocess/`
        : `${centro}/businessprocess/${id}`
    const response = await axios.get(url);

    return response.data
  },

  bpmap: async (centro) => {
    const response = await axios.get(`${centro}/businessprocess/bpmap/`,);
    return response.data;
  },

  post: async (centro, data) => {
    const url = `${centro}/businessprocess/`
    const response = await axios({
      method: 'post',
      url: url,
      data: data,
      config: {
        headers: { 'Content-Type': 'application/json' },
      },
    });
    return response.data;
  },

  put: async (centro, id, data) => {
    const url = `${centro}/businessprocess/${id}/`;
    const response = await axios.put(url, data);
    return response.data;
  },


  creation_bp_data: async (site_id, filters, cancel_token) => {
    // TODO: do the back-end call
    const langs = [['es','Español'],['ca','Català'],['en','English']];
    let data ={
      'model':{'props': 
          [
            {'id':	"id", 'label': "Id", 'required':	true, 'cols':	4, 'class': null, 'component': "TextInput", 'placeholder': "Id"},
            {
              id:	"type",
              label: "Type",
              required: true,
              'items_funct': (bp) => {return (Object.keys(API_TO_QFIELD).filter(it => it !== 'fallback') || []).sort()},
              cols:	4,
              class: null,
              component: "Select",
              placeholder: "Type",
            },
            {id: "name", label: "Name", required: true, cols:	4, class: null, component: "DictInput", placeholder: "Name", 'select_key': true, 'key_items': langs}
          ],
        },
      'states': {'props': 
          [
            {'id':'id', 'label': 'Id', 'component': 'TextInput', 'required': true},
            {'id':'name', 'label': 'Name', 'component': 'DictInput', 'required': true, 'select_key': true, 'key_items': langs},
            {'id':'limit_time', 'label': 'Limit date', 'component': 'Select', 'items_funct': (bp) => {return Object.entries(bp.raw.model).filter(it => it[1].type == "BPDateField").map(it => it[0])}},
            {'id':'responsible', 'label': 'Responsable', 'component': 'Select', 'items_funct': (bp) => {return (bp.raw.roles).map(it => it.id)}},
            {'id':'color', 'label': 'Color', 'component': 'TextInput'},
            {'id':'filtered', 'label': 'Filtered', 'component': 'CheckboxInput'},
            {'id':'final', 'label': 'Final', 'component': 'CheckboxInput'}
          ]
        },
        'roles': {'props': 
          [
            {'id':'id', 'label': 'Id', 'component': 'TextInput', 'required': true},
            {'id':'name', 'label': 'Name', 'component': 'DictInput', 'required': true, 'select_key': true, 'key_items': langs},
          ]
        },
        'transitions': {'props':
          [
            {'id':'id', 'label': 'Id', 'component': 'TextInput', 'required': true},
            {'id':'name', 'label': 'Name', 'component': 'DictInput', 'required': true, 'select_key': true, 'key_items': langs},
            {'id':'state_in', 'label': 'State in', 'component': 'Select', 'items_funct': (bp) => {return bp.raw.states.map(it => [it.id,it.name[bp.lang]])}},
            {'id':'state_out', 'label': 'State out', 'component': 'Select', 'items_funct': (bp) => {return bp.raw.states.map(it => [it.id,it.name[bp.lang]])}},
          ]
        },
        'inlines': {
          'props':
            [
              {
                'id':'id',
                'label': 'Id',
                'component': 'TextInput',
                'required': true,
              },
              {
                'id':'type',
                'label': 'Type',
                'component': 'Select',
                'required': true,
                'items_funct': (bp) => {return ['BPInlineBoxData',
                                                'BPInlineBoxRelated',
                                                'BPInlineBoxDocuments',
                                                'BPInlineBoxWorkflow',
                                                'BPInlineBoxComunications',
                                                'BPInlineBoxDownloadsTracker',
                                                'BPInlineBoxSimpleLayout',
                                                'BPInlineBoxVersions',
                                                'BPIndicatorTrackingBox',
                                                'BPIndicatorBox',
                                                'BPIndicatorRiskBox']
                                        },
              },
              {
                'id':'name',
                'label': 'Name',
                'component': 'DictInput',
                'required': true,
                'select_key': true,
                'key_items': langs,
              },
            ],
          'data': {
            'props':
              [
                {
                  'id':'id',
                  'label': 'Id',
                  'component': 'TextInput',
                  'required': true,
                  'readonly': false,//
                  'value_funct': (field,lang) => { return (field || {}).id || 'data'}
                },
                {
                  'id':'name',
                  'label': 'Name',
                  'component': 'DictInput',
                  'required': true,
                  'readonly': false,//
                  'value_funct': (field,lang) => { return (field || {}).name || {"es": "Datos","ca": "Dades","en": "Data"}},
                  'select_key': true, 'key_items': langs
                },
                {
                  'id':'type',
                  'label': 'Type',
                  'component': 'Select',
                  'required': true,
                  'readonly': false,//
                  'items_funct': (bp) => {return ['BPInlineBoxData']},
                  'value_funct': (field,lang) => { return (field || {}).type || 'BPInlineBoxData'}
                },
                {
                  'id':'content',
                  'label': 'Content',
                  'component': 'AutocompleteSelect',
                  'multiple': true,
                  'chips': true,
                  'items_funct': (bp) => {return (bp.raw.transitions).map(it => ([it.id,it.name[bp.lang]]))},
                  'value_funct': (field,lang) => { return (field || {}).content || []}
                },
              ],
          },
        },
        'filters': {
          'props': [
            {
              'id':'id',
              'label': 'Id',
              'component': 'Select',
              'required': true,
              'items_funct': (bp) => {return [...(Object.entries(bp.raw.model || {}) || []).map(it => [it[0],it[1].name[bp.lang]]),['current_workflow_responsible','Current workflow responsible'],['current_workflow_state','Current workflow state']]}
            },
            {'id': 'cols', 'label': 'Columns', 'component': 'NumericInput', 'required': true, 'value': 2},
            {'id':'multiple', 'label': 'Multiple', 'component': 'CheckboxInput'}
          ],
        },
        'columns': {
          'props': [
            {
              'id':'value',
              'label': 'Id',
              'component': 'Select',
              'required': true,
              'items_funct': (bp) => {return [...(Object.entries(bp.raw.model || {}) || []).map(it => [it[0],it[1].name[bp.lang]]), ['data-table-expand','Data table expand']]}
            },
            {
              'id':'text',
              'label': 'Text',
              'component': 'DictInput',
              'required': true,
              'select_key': true,
              'key_items': langs,
            },
            {'id':'sortable', 'label': 'Sortable', 'component': 'CheckboxInput'},
            {'id':'filterable', 'label': 'Filtrable', 'component': 'CheckboxInput'},
          ],

        },
    };


    return data;
  },
};
